/**
 * PlayerAugmentationsPanel Component (CSS Theme)
 * Uses CSS classes from chess-components.css instead of inline styles
 */

import {
  type Augmentation,
  getAugmentation,
} from "@cloudnest/augmented-chess-engine";
import type { PlayerAugmentationsPanelProps } from "../../types";

interface AugmentationListProps {
  title: string;
  augIds: string[];
  color: "WHITE" | "BLACK";
}

function AugmentationList({
  title,
  augIds,
  color,
}: AugmentationListProps): JSX.Element {
  const augmentations = augIds
    .map((id) => getAugmentation(id))
    .filter((aug): aug is Augmentation => aug !== undefined);

  const headerClass =
    color === "WHITE"
      ? "chess-panel-header chess-panel-header-white"
      : "chess-panel-header chess-panel-header-black";

  const indicator = color === "WHITE" ? "\u2654" : "\u265A";

  return (
    <div className="chess-panel-section">
      <h4 className={headerClass}>
        <span>{indicator}</span>
        {title}
      </h4>
      {augmentations.length === 0 ? (
        <p className="chess-panel-empty">증강 없음</p>
      ) : (
        <ul className="chess-panel-list">
          {augmentations.map((aug) => (
            <li
              key={aug.id}
              className="chess-panel-item"
              title={aug.descriptionKo ?? aug.description}
            >
              <span className="chess-panel-item-name">
                {aug.nameKo ?? aug.name}
              </span>
              <span className="chess-panel-item-description">
                {aug.descriptionKo ?? aug.description}
              </span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export function PlayerAugmentationsPanelThemed({
  gameState,
  whiteAugmentations,
  blackAugmentations,
}: PlayerAugmentationsPanelProps): JSX.Element | null {
  if (gameState.phase === "AUGMENTATION_SELECTION") {
    return null;
  }

  return (
    <div className="chess-panel">
      <AugmentationList title="백" augIds={whiteAugmentations} color="WHITE" />
      <AugmentationList title="흑" augIds={blackAugmentations} color="BLACK" />
    </div>
  );
}
